import styles from 'pages/Patient/SubmitSample/SubmitSample.module.scss';
import usePageWithSidebarContent from 'app/hooks/usePageWithSidebarContent';
import { Page } from 'app/types/ProductCatalog';
import PageHeader from 'components/PageHeader/PageHeader';
import PageWithSidebar from 'components/PageWithSidebar/PageWithSidebar';
import SampleCollectionInstructions from 'components/SampleCollectionInstructions/SampleCollectionInstructions';
import { Body, Heading } from 'components/Typography';

import React, { useEffect, useMemo } from 'react';
import { Helmet } from 'react-helmet-async';

const SubmitSample: React.FC<Page> = ({ setPageHeader }) => {
  const sectionTitles = useMemo(() => [ 'Shipping', 'Collection Protocol' ], []);
  const { sidebarItems, sectionItems } = usePageWithSidebarContent(sectionTitles);

  useEffect(() => setPageHeader(<PageHeader sidebarItems={sidebarItems} />), [ setPageHeader, sidebarItems ]);

  return (
    <>
      <Helmet title="Submit sample" />
      <PageWithSidebar sidebarItems={sidebarItems} className={styles.submitSample}>
        <div id={sectionItems[0].id} ref={sectionItems[0].ref}>

          <Heading variant="H3" className={styles.submitSample__title}>Sample Shipping Instructions</Heading>

          <Body variant="L">
            Our high complexity molecular laboratory is located at our headquarters at<br />
            <b>14350 Commerce Way, Miami Lakes, FL 33016.</b>
            <br /><br />
            <b>
              All biospecimens must be shipped to this address for sequencing and analysis, regardless of whether the collection was administered at a physician
              location or self administered by the patient at home.
            </b>
            <br /><br />
            The Galatea Bio DNA kit will include collection sample collection instructions (copy of instruction you can see if you’ll scrolling down) for how to
            administer retrieval and safe repackaging of your sample using the ORAcollect®•Dx(OCD-100) tubes. The kit will also be accompanied by a prepaid
            shipping label back to our headquarters. If you do not have one please contact: <a href="mailto:info@galatea.bio">info@galatea.bio</a>
          </Body>

        </div>

        <div className={styles.submitSample__separator} />

        <div id={sectionItems[1].id} ref={sectionItems[1].ref}>
          <SampleCollectionInstructions />
        </div>
      </PageWithSidebar>
    </>
  );
};

export default SubmitSample;
